export const Arrow = () => (
  <svg width="21" height="36" viewBox="0 0 21 36" xmlns="http://www.w3.org/2000/svg">
    <path
      fill="#FFF"
      fillRule="evenodd"
      opacity=".4"
      d="M0 4.497 4.199 0l16.795 17.988-.012.012.012.012L4.2 36 0 31.503 12.608 18z"
    />
  </svg>
);
